export const PIPELINE_ID = '59313800';
export const DEFAULT_OWNER_ID = '729254194'; // muzz.salim@apty.io
export const APTY_PARTNER = 'Apty';

// API Base URL based on environment
export const API_BASE_URL = window.location.hostname === 'localhost' 
  ? 'http://localhost:8080/enablement/api'
  : 'https://demo.apty.io/enablement/api'; 
